import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import Help from 'common/Help';
import Tooltip from 'common/Tooltip';

import { withFieldProps } from 'hooks/useFieldProps';
import RawHtml from '../common/RawHtml';
import selectorStyles from './styles/selector';

const styles = (theme) => {
  const { spacing } = theme;
  const rootStyles = selectorStyles(theme);
  return {
    root: {
      ...rootStyles,
      '& button': {
        ...rootStyles['& button'],
        padding: [0, spacing.unit * 2],
      },
    },
  };
};

const LookupSelector = ({ classes, error, help, name, onChange, options, tooltip, value }) => {
  useEffect(() => {
    if (!value) {
      onChange(name, Object.keys(options)[0]);
    }
  }, [name, onChange, options, value]);
  return (
    <>
      <div className={classnames('btn-group', classes.root)}>
        {Object.keys(options).map((key) => (
          <RawHtml
            key={key}
            type="button"
            onClick={() => onChange(name, key)}
            className={classnames({ active: key === value })}
            aria-describedby={
              classnames({
                [`help-${name}`]: help,
                [`error-${name}`]: error,
              }) || undefined
            }
          >
            {options[key]}
          </RawHtml>
        ))}
        <Tooltip tooltip={tooltip} labeledBy={`label-${name}`} />
        <Help help={help} id={`help-${name}`} />
      </div>
    </>
  );
};

LookupSelector.propTypes = {
  error: PropTypes.bool.isRequired,
  help: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.shape({}).isRequired,
  tooltip: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

const LookupSelectorStyled = withStyles(styles)(LookupSelector);

const mapStateToProps = ({ fields }, { name }) => {
  const field = fields[name];
  return {
    options: field.lookupValues,
  };
};

export default withFieldProps(mapStateToProps)(LookupSelectorStyled);
